import { useEffect, useState } from 'react';
import { SUPPORT_EMAIL } from '../data/constants';
import { apiRequest } from '../utils/api';

export function useSupportEmail(initialValue = SUPPORT_EMAIL, timeoutMs = 10000) {
  const [supportEmail, setSupportEmail] = useState(initialValue || SUPPORT_EMAIL);

  useEffect(() => {
    let cancelled = false;

    async function loadSupportEmail() {
      try {
        const res = await apiRequest('/support-mail', { timeoutMs });
        const nextEmail = String(res.support?.support_email || '').trim().toLowerCase();
        if (!cancelled && nextEmail) {
          setSupportEmail(nextEmail);
        }
      } catch (_) {}
    }

    loadSupportEmail();
    return () => {
      cancelled = true;
    };
  }, [timeoutMs]);

  return supportEmail;
}
